// extracted by mini-css-extract-plugin
module.exports = {"component":"admin_edit_menu_item_component__Wb0WT"};